import { useEffect } from 'react';

//Custom Hook para verificar que se hizo algún click fuera del contenedor de un elemento usado como referencia.
const useClickOutside = (ref, handleClickOutside) => {

  useEffect(() => { // Se ejecuta con cada cambio de la referencia o del click
    
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handleClickOutside(event);
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ref, handleClickOutside]);
};

export default useClickOutside;